module.exports = __webpack_public_path__ + "media/images/og-802db6bfa54402e93ba16d0cdcd80b28.png";